module.exports = "<section id=\"jb-modal\" [hidden]=\"!showModal\">\n  <div id=\"modal-content\" (clickOutside)=\"closeModal()\" [clickOutsideExclude]=\"excludes\">\n    <div id=\"close-modal\" (click)=\"closeModal()\"></div>\n    <ng-content></ng-content>\n  </div>\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/global/modal/modal.component.html
// module id = WPuH
// module chunks = 0